function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import { Body } from "./body/Body";
import { Header } from "./header/Header";
import { getDataState } from "./helpers";
import { TableWrapper } from "./Table.styles";
export var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  _createClass(Table, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return {
        data: getDataState(nextProps, prevState.sorting)
      };
    }
  }]);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSort", function (sorting) {
      return _this.setState({
        sorting: sorting,
        data: getDataState(_this.props, sorting)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRowClick", function (_ref) {
      var id = _ref.id;
      return _this.setExpandedRowId(_this.state.expandedRowId === id ? undefined : id);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setExpandedRowId", function (id) {
      return _this.setState({
        expandedRowId: id
      });
    });

    _this.state = {
      data: {
        grouped: false,
        rows: []
      },
      expandedRowId: undefined,
      sorting: props.defaultSorting || undefined
    };
    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          detailsComponent = _this$props.detailsComponent,
          showHeader = _this$props.showHeader,
          grouping = _this$props.grouping;
      var _this$state = this.state,
          data = _this$state.data,
          expandedRowId = _this$state.expandedRowId,
          sorting = _this$state.sorting;
      var onRowClick = detailsComponent ? this.handleRowClick : undefined;
      return React.createElement(TableWrapper, {
        className: "table__wrapper"
      }, showHeader && React.createElement(Header, {
        columns: columns,
        sorting: sorting,
        onSort: this.handleSort
      }), React.createElement(Body, {
        columns: columns,
        data: data,
        detailsComponent: detailsComponent,
        expandedRowId: expandedRowId,
        onRowClick: onRowClick,
        groupingComponent: grouping ? grouping.component : undefined
      }));
    }
  }]);

  return Table;
}(Component);

_defineProperty(Table, "defaultProps", {
  data: [],
  showHeader: true
});